import { Dispatch, FC, SetStateAction, useMemo } from "react";
import {
    SearchBar,
    SearchBarDataHandler,
} from "../../../assets/components/SearchBar/SearchBar";
import { OptionList } from "../../../assets/helpers/helpers";
import { UsersT } from "../../../models/models";
import { ChangeType, TargetArea } from "../model";
import { getEnumOptionList } from "../helpers";

interface Props {
    users: UsersT;
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
}
const HistorySearchBar: FC<Props> = ({ users, dataHandler }) => {
    const usersOptionList: OptionList = useMemo(() => {
        return users.map(({ username, id }) => {
            const removedEmailAttr =
                username.indexOf("@") !== -1
                    ? username.substring(0, username.indexOf("@"))
                    : username;

            return {
                id: id,
                name: removedEmailAttr,
            };
        }) as OptionList;
    }, [users]);

    const targetAreaOptionList: OptionList = useMemo(
        () => getEnumOptionList(TargetArea),
        []
    );
    const changeTypeOptionList: OptionList = useMemo(
        () => getEnumOptionList(ChangeType),
        []
    );

    return (
        <SearchBar
            usersOptions={usersOptionList}
            dataHandler={dataHandler}
            changeTypeOptions={changeTypeOptionList}
            targetAreaOptions={targetAreaOptionList}
            showComponents={{
                dataPikerHistoryActionDate: true,
            }}
        />
    );
};

export default HistorySearchBar;
